import Vue from "vue";
import App from "./App.vue";
import router, { passStoreToRouter } from "./router";

import initSentry from "@/plugins/sentry";
import i18n, { setLocale } from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";

import cookie from "@/utils/cookie";

import store from "./store";

import "@/plugins/chamaileon.js"; // chamaileon-frontend-modules
import chamaileonFrontendUtils from "@edmdesigner/chamaileon-frontend-utils";

(async () => {
	const hostName = location.hostname;
	let environmentName = cookie.getCookie("env");
	const urlParams = new URLSearchParams(window.location.search);
	const envFromQuery = urlParams.get("env");
	if (typeof envFromQuery === "string" && envFromQuery !== "") {
		environmentName = envFromQuery;
	}

	if (!environmentName) {
		if (hostName.includes("app.chamaileon.io")) {
			environmentName = "prod";
		} else if (hostName.includes("app-santander.chamaileon.io")) {
			environmentName = "prod-santander";
		} else if (hostName.includes("localhost")) {
			environmentName = "dev";
		}
	}

	// load chamaileon logo create script
	chamaileonFrontendUtils.addScript("https://cdn.chamaileon.io/assets/createLogoWithText.js");

	Vue.config.productionTip = false;

	await store.dispatch("environment/setEnvironmentName", environmentName);

	const locale = "en"; // Later we can have it from param or config
	setLocale(locale);

	initSentry();

	passStoreToRouter(store); // needs store, but tests fail if we import it directly

	new Vue({
		vuetify,
		i18n,
		router,
		store,
		mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
		render: h => h(App),
	}).$mount("#app");
})();
